"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const DatePicker_1 = require("@mui/x-date-pickers/DatePicker");
const timestamp_pb_1 = require("google-protobuf/google/protobuf/timestamp_pb");
const googleProtobufConverters_1 = require("@mesh/common-js/dist/googleProtobufConverters");
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
const i8n_1 = require("@mesh/common-js/dist/i8n");
require("@mui/x-date-pickers/AdapterDayjs");
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
function DateField(props) {
    return ((0, jsx_runtime_1.jsx)(DatePicker_1.DatePicker, Object.assign({}, props, { timezone: props.timezone ? (0, i8n_1.timezoneToString)(props.timezone) : "system", value: props.value
            ? (0, googleProtobufConverters_1.protobufTimestampToDayjs)(props.value)
            : (0, googleProtobufConverters_1.protobufTimestampToDayjs)(new timestamp_pb_1.Timestamp()), onChange: (newValue) => {
            if (!props.onChange) {
                return;
            }
            props.onChange(newValue ? (0, googleProtobufConverters_1.dayjsToProtobufTimestamp)(newValue) : new timestamp_pb_1.Timestamp());
        } })));
}
exports.DateField = DateField;
